<template>
<footer>
    <p>Autoclases Pablo - Todos los derechos reservados copyright 2023</p>
</footer>
</template>

<script>
  export default{
      name: "Footer"
  }
</script>

<style scoped>
footer p {
    background: #1E1E1E;
    color: white;
    padding: 30px;
    text-align: center;
}
</style>